/** Shared painting/tool constants used by both Viewport3D and the toolbar. */

export const TEX_RESOLUTIONS = [
  { w: 1024, h: 512, label: '1K' },
  { w: 2048, h: 1024, label: '2K' },
  { w: 3072, h: 1536, label: '3K' },
  { w: 4608, h: 2304, label: '4.5K' },
] as const;

export type TexRes = typeof TEX_RESOLUTIONS[number];

export const BRUSH_MIN = 0.0025;
export const BRUSH_MAX = 0.4;

export const TEXT_FONTS = [
  'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Georgia',
  'Impact', 'Palatino Linotype', 'Tahoma', 'Times New Roman', 'Trebuchet MS', 'Verdana',
] as const;
